import { ACTION_TYPES } from './index';

export const updateCompanyIsSaved = (payload = {}) => ({
  type: ACTION_TYPES.COMPANY_IS_SAVED,
  payload,
});

export const updateUserFavouriteCompanies = (payload = {}) => ({
  type: ACTION_TYPES.USER_FAVOURITE_COMPANIES,
  payload,
});
